import { CopyFilled } from "@ant-design/icons";
import {  Form, Input, Space, Typography } from "antd";
import { ModalWrapper } from "../index.styled";
import { ShareWrapper } from "./index.styled";
const {Text} = Typography;

interface AddTokenModalProps{
    visible: boolean
    onClose?: () => void
    onCopied?: () => void
    text?: string
}
export const ShareModal = (props: AddTokenModalProps) => {
    const {visible, onCopied, onClose, text} = props;
    
    return (
          <ModalWrapper  
                title={
                    <Space direction="vertical" size={0}>
                        <Text className="m-title">Share</Text>
                        <Text style={{
                            fontWeight: 400,
                            fontSize: 14,
                            color: 'var(--disabled-color)'
                        }}>Click to copy URL</Text>
                    </Space>
                } 
                footer={null}
                visible={visible}
                onCancel={onClose}
                >
                    <ShareWrapper>
                        <Form.Item
                        >
                            <Input value={text??"https://pulsesac.com"}  disabled={true} suffix={<CopyFilled onClick={onCopied} />}/>
                        </Form.Item>
                    </ShareWrapper>
                    
            
          </ModalWrapper>
    );
};